import { useCopyClipboard } from '@cocoonspace/shared/hooks/use-copy-clipboard.hook'
import { Link, Share } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import { Button } from '~/components/ui/button'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '~/components/ui/popover'
import { cn } from '~/lib/utils'

export interface ShareBoxProps {
	title: string
	link?: string
	activatorClassName?: string
	onCopyBtnClick?: () => void
}

export const ShareBox = ({
	link,
	title,
	activatorClassName,
	onCopyBtnClick,
}: ShareBoxProps) => {
	const { t } = useTranslation()
	const { isCopied, copyToClipboard } = useCopyClipboard(2000)

	const currentPageLink =
		typeof window !== 'undefined' ? window.location.href : ''

	const linkTocopy = link ? link : currentPageLink

	return (
		<Popover>
			<PopoverTrigger asChild>
				<button
					type='button'
					title={title}
					className={cn('!outline-none flex items-center', activatorClassName)}
				>
					<Share size={22} />
				</button>
			</PopoverTrigger>

			<PopoverContent
				title={title}
				className='flex flex-col items-center gap-4 overflow-hidden md:flex-row'
			>
				<div className='flex items-center gap-2 overflow-hidden max-md:w-full md:flex-1'>
					<Link
						size={16}
						className='shrink-0 text-primary'
					/>

					<div className='max-w-[300px] truncate border-b border-dashed text-foreground/50 text-sm'>
						{linkTocopy}
					</div>
				</div>

				<Button
					variant='outline'
					size='sm'
					className='max-md:w-full'
					onClick={() => {
						copyToClipboard(linkTocopy)
						onCopyBtnClick?.()
					}}
				>
					{isCopied
						? t('actions:copyLink.successMessage')
						: t('actions:copyLink.btnLabel')}
				</Button>
			</PopoverContent>
		</Popover>
	)
}
